module.exports = __webpack_public_path__ + "static/media/icon-no-background.6d0c1685.png";